import { DataTable, Select2 } from "@fdoh/health-react";
import { Layout, Page, UserSelect, Button, usePath, LayoutContainer, useAppConfig, Input } from "@fdoh/health-ui-react";
import { ApplicationDetails, ApplicationInspection } from "../Components/Home/ApplicationDetails.types";
import { useData } from "../../hooks";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef, useContext } from "react";
import { toast } from "react-toastify";
import useClient from "../../hooks/useInspectionClient";
import SearchResultsPage from "./SearchResults";
import { boolean, ref } from "yup";
import { recentlyOpenedColumns, submittedColumns } from "./Home.types";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
import useProfile from "../../hooks/useProfile";
import { useMsal } from "@azure/msal-react";


export const HomePage = () => {

  const history = useHistory();
  const client = useClient();
  const path = usePath();
  const inputRef = useRef<HTMLInputElement>(null);
  const [applicationData, setApplicationData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [noResults, setNoResults] = useState(false);
  const config =  useAppConfig();
  const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];

   const user =  useProfile(application) as UserSecurityInput;
  const { accounts } = useMsal();    
    const userEmail = accounts[0] && accounts[0].username;
  let applicationInspections= useData<ApplicationInspection[]>('ApplicationInspection/GetApplicationInspectionsByEmail/' + userEmail);
    
  const distantFuture = new Date(8640000000000000)
  let Recentlyopened = applicationInspections?.filter(x => x.inspectionStatusId == 1 && x.isActive == true)
    .sort((a, b) => {
      let dateA = a.dateUpdated ? new Date(a.dateUpdated) : distantFuture
      let dateB = b.dateUpdated ? new Date(b.dateUpdated) : distantFuture
      return dateB.getTime() - dateA.getTime()
    });
  let submittedApplications = applicationInspections?.filter(x => x.inspectionStatusId != 1 && x.isActive == true).sort((a, b) => {
    let dateA = a.dateUpdated ? new Date(a.dateUpdated) : distantFuture
    let dateB = b.dateUpdated ? new Date(b.dateUpdated) : distantFuture
    return dateB.getTime() - dateA.getTime()
  });
 
  const [showPreviousInspections, setShowPreviousInspections] = useState(false);

  const searchApplications = async () => {
      if (inputRef.current?.value !== '') {
          try {
              let endpoint = 'Application/getapplicationbyapnumber/' + inputRef.current?.value;
              const response = await client.api(endpoint).get();
              setApplicationData(response.data as any);
              setShowPreviousInspections(false); // Reset previous inspections view on new search
              setNoResults(false); //Reset search view on new search
              if (response.data.applicationId != 0) {
                  updateSearchedRecord(response.data);
              }
          } catch (error: any) {
              toast.error(error);
          }
      }
      else {      
          setNoResults(true);
      }
  }

  const updateSearchedRecord = async (applicationDetailData: ApplicationDetails) => {
    let endpoint = 'ApplicationInspection/';
    const activeInspections = applicationDetailData?.applicationInspections?.filter(x => x.inspectionStatusId == 1 && x.isActive == true);
    if (activeInspections.length > 0) {
      activeInspections[0].dateUpdated = new Date();
      activeInspections[0].updatedBy = user?.userName;
      const updateResponse = await client.api(endpoint).post(activeInspections[0]);
    }

  }
  return (
      <Page.Container>
        <Page.Header preTitle="" title="" />
        <Page.Body>
          <Layout.Container>
            <div className="card bg-welcome text-primary-fg">

              <div className="card-body text-center">
                <h1 className="bg-welcome title">Welcome!</h1>
                <p>Please enter an AP number or Permit Number to locate or create a new inspection.</p>
                <div className="row">
                  <div className="col-xl-4"></div>
                  <div className="col-xl-4">
                    <div className="input-group mb-2">
                      <input
                        type="text"
                        className="form-control"
                        ref={inputRef}
                        name="searchApplication"
                        defaultValue={""} />
                      <Button className="btn btn-primary ms-auto" onClick={searchApplications}>Go</Button>
                    </div>
                  </div>
                  <div className="col-xl-4"></div>
                </div>
                <div>
                  {noResults && (
                    <div className="d-flex flex-column align-items-center">
                      <p className="bg-welcome msg flex-column align-items-center">
                        Please enter an AP number or Permit Number
                      </p>
                    </div>
                  )}
                  {inputRef.current?.value !== '' && applicationData && (
                    <SearchResultsPage
                      appData={applicationData}
                      apNumber={inputRef.current?.value}
                      showHidePreviousInspections={showPreviousInspections}
                      setShowPreviousInspections={setShowPreviousInspections}
                    />
                  )}
                </div>
              </div>
            </div>

          </Layout.Container>
          <LayoutContainer>
            <div className="page-body">
              <div className="container-xl">
                <div className="row row-cards">
                  <div className="col-md-6 col-lg-6">
                    {Recentlyopened && (<DataTable
                      name="applicationDetails"
                      columns={recentlyOpenedColumns}
                      data={Recentlyopened}
                      title="Recently Opened"
                      globalFilter
                      striped
                      vcenter />)}


                  </div>
                  <div className="col-md-6 col-lg-6">

                    {submittedApplications && (<DataTable
                      name="applicationDetails"
                      columns={submittedColumns}
                      data={submittedApplications}
                      title="Submitted"
                      globalFilter
                      striped
                      vcenter />)}

                  </div>
                </div>
              </div>
            </div>
          </LayoutContainer>
        </Page.Body>
      </Page.Container>
  );
};

export default HomePage;



